import { cva, type VariantProps } from 'class-variance-authority';

export const controlVariants = cva(
    'flex w-full rounded-xl border border-input bg-card px-3 text-base shadow-sm transition-[background-color,border-color,box-shadow,color] duration-150 ease-out placeholder:text-muted-foreground/80 focus-visible:border-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/20 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
    {
        variants: {
            size: {
                default: 'h-10 py-2',
                textarea: 'min-h-[96px] py-2',
            },
        },
        defaultVariants: {
            size: 'default',
        },
    },
);

export type ControlVariants = VariantProps<typeof controlVariants>;
